"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _FormGroup = _interopRequireDefault(require("@material-ui/core/FormGroup"));

var _Switch = _interopRequireDefault(require("@material-ui/core/Switch"));

var _styles = require("@material-ui/core/styles");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["classes"];
var SwitchIOS = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      width: 42,
      height: 26,
      padding: 0,
      margin: theme.spacing(1)
    },
    switchBase: {
      padding: 1,
      '&$checked': {
        transform: 'translateX(16px)',
        color: theme.palette.common.white,
        '& + $track': {
          backgroundColor: '#7AD651',
          opacity: 1,
          border: 'none'
        }
      },
      '&$focusVisible $thumb': {
        color: '#7AD651',
        border: '6px solid #7AD651'
      }
    },
    thumb: {
      width: 24,
      height: 24
    },
    track: {
      borderRadius: 26 / 2,
      border: "1px solid ".concat(theme.palette.grey[400]),
      backgroundColor: '#DEE0ED',
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border'])
    },
    checked: {},
    focusVisible: {}
  };
})(function (_ref) {
  var classes = _ref.classes,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Switch.default, (0, _extends2.default)({
    focusVisibleClassName: classes.focusVisible,
    disableRipple: true,
    classes: {
      root: classes.root,
      switchBase: classes.switchBase,
      thumb: classes.thumb,
      track: classes.track,
      checked: classes.checked
    }
  }, props));
});

var Switcher = function Switcher(_ref2) {
  var checked = _ref2.checked,
      handleChange = _ref2.handleChange;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormGroup.default, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControlLabel.default, {
      control: /*#__PURE__*/(0, _jsxRuntime.jsx)(SwitchIOS, {
        checked: checked,
        onChange: handleChange
      })
    })
  });
};

var _default = Switcher;
exports.default = _default;